/* eslint-disable */
import irelandApi from '../irelandApi';

export const getArticle = id => (dispatch) => {
  dispatch({type: 'GET_ARTICLE_PENDING', payload: []});

  return irelandApi.get(`/api/articles/${id}?location=website`)
    .then((response) => {
      let payload = response.data ? response.data : {data: false};
      dispatch({type: 'GET_ARTICLE_FULFILLED', payLoad: payload});      
    })
    .catch((error) => {
      dispatch({type: 'GET_ARTICLE_REJECTED', payLoad: error});
    });
};
